

































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  Variable as IVariable,
  VariableTypeEnum
} from "@/api-v2/document-generator/models/variable";
import DocTemplateVariablesItem from "@/components/doc-tempates/DocTemplateVariablesItem.vue";

@Component({
  components: { DocTemplateVariablesItem }
})
export default class DocTemplateVariables extends Vue {
  @Prop() variables!: IVariable[];

  get stringVar() {
    return this.variables?.filter(
      el => el?.type === VariableTypeEnum.StringVariable
    );
  }

  get imageVar() {
    return this.variables?.filter(
      el => el?.type === VariableTypeEnum.ImageVariable
    );
  }

  get listVar() {
    return this.variables?.filter(
      el => el?.type === VariableTypeEnum.ListVariable
    );
  }
}
